import { theme } from '@contrast-security-inc/design-system-foundations'
import { css, cx } from '@emotion/css'
import React from 'react'
import { LibraryGridPanelID } from '../../helpers/drilldown-ui-interfaces'

const restrictedCss = css`
  padding-bottom: 1px;
  color: ${theme.color.red50} !important;

  &:hover[data-supports-details='true'] {
    cursor: pointer;
    text-decoration: underline;
  }
`

const restrictedItalicCss = cx(
  restrictedCss,
  css`
    font-style: italic;
  `
)

const unrestrictedCss = css`
  padding-bottom: 1px;
  color: ${theme.color.neutral100};

  &:hover[data-supports-details='true'] {
    color: ${theme.color.neutral100};
    cursor: pointer;
    text-decoration: underline;
  }
`

const unrestrictedItalicCss = cx(
  unrestrictedCss,
  css`
    font-style: italic;
  `
)

type LinkClassName =
  | 'restrictedItalic'
  | 'restricted'
  | 'unrestrictedItalic'
  | 'unrestricted'

const cssMap: Record<LinkClassName, string> = {
  restricted: restrictedCss,
  restrictedItalic: restrictedItalicCss,
  unrestricted: unrestrictedCss,
  unrestrictedItalic: unrestrictedItalicCss
}

export function getLibraryNameLinkClassName({
  hasRestriction,
  unused
}: {
  hasRestriction: boolean
  unused: boolean
}): LinkClassName {
  if (hasRestriction) {
    if (unused) {
      return 'restrictedItalic'
    }

    return 'restricted'
  }

  if (unused) {
    return 'unrestrictedItalic'
  }

  return 'unrestricted'
}

export function LibraryNameLink({
  name,
  hasRestriction,
  usage,
  className,
  onClick,
  libraryId,
  setSelectedPanelTabId
}: {
  organizationID: string
  hash: string
  name: string
  version?: string
  hasRestriction: boolean
  usage: {
    totalUsed: number
  }
  className?: string
  onClick?: (props?: any) => void
  libraryId?: string
  setSelectedPanelTabId?: React.Dispatch<
    React.SetStateAction<LibraryGridPanelID>
  >
}) {
  const unused = usage.totalUsed === 0

  const supportsDrilldown = !!(setSelectedPanelTabId && onClick)

  return (
    <div
      data-testid={`grid-library-name-${name}`}
      data-e2e={`grid-library-name`}
      className={cx(
        cssMap[getLibraryNameLinkClassName({ hasRestriction, unused })],
        className
      )}
      data-supports-details={supportsDrilldown}
      onClick={() => {
        if (supportsDrilldown) {
          setSelectedPanelTabId(LibraryGridPanelID.Overview)
          onClick(libraryId)
        }
      }}
    >
      {name}
    </div>
  )
}
